import { gql } from "@apollo/client";

export const HANDOVER_CARRIER_FIELDS = gql`
  fragment HandoverCarrierFields on HandoverCarrierType {
    id
    carrierCode
    carrierName
    shortCarrierName
    carrierType
    contactName
    contactPhone
    centerWarehouseIds
    status
    createdAt
    updatedAt
  }
`;

export interface HandoverCarrierType {
  id?: string;
  carrierCode?: number | null;
  carrierName: string;
  shortCarrierName?: string | null;
  carrierType: number;
  contactName?: string | null;
  contactPhone?: string | null;
  centerWarehouseIds: string[];
  status: number;
  createdAt?: number | null;
  updatedAt?: number | null;
}
